export default "__VITE_ASSET__5UtrHh5d__"